module.exports = __webpack_public_path__ + "static/img/landManage.23dd3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landManage.jpg
// module id = dE4I
// module chunks = 1